"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _DateTimePicker = require("./DateTimePicker.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DateTimePicker = exports.DateTimePicker = function DateTimePicker(_ref) {
  var id = _ref.id,
    dataTestId = _ref.dataTestId,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'MMMM d, yyyy' : _ref$dateFormat,
    _ref$timeIntervals = _ref.timeIntervals,
    timeIntervals = _ref$timeIntervals === void 0 ? 15 : _ref$timeIntervals,
    startOpen = _ref.startOpen,
    disabled = _ref.disabled,
    use12Hours = _ref.use12Hours,
    filterTimeFlag = _ref.filterTimeFlag,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    value = _ref.value,
    ariaDescribedBy = _ref.ariaDescribedBy,
    ariaLabelledBy = _ref.ariaLabelledBy,
    className = _ref.className,
    _ref$clearButtonClass = _ref.clearButtonClassName,
    clearButtonClassName = _ref$clearButtonClass === void 0 ? 'clear-button' : _ref$clearButtonClass,
    onChange = _ref.onChange,
    filterTime = _ref.filterTime,
    onChangeRaw = _ref.onChangeRaw,
    onBlur = _ref.onBlur;
  var timeFormat = use12Hours ? 'h:mm a' : 'H:mm';
  var dateTimeFormat = "".concat(dateFormat, " ").concat(timeFormat);
  return /*#__PURE__*/_react["default"].createElement(_DateTimePicker.Wrapper, {
    "data-testid": dataTestId,
    $isDisabled: disabled,
    "aria-describedby": ariaDescribedBy
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    id: id,
    selected: value,
    onChange: onChange,
    dateFormat: dateTimeFormat,
    showTimeSelect: true,
    timeFormat: timeFormat,
    timeIntervals: timeIntervals,
    startOpen: startOpen,
    disabled: disabled,
    minDate: minDate,
    maxDate: maxDate,
    filterTime: filterTimeFlag ? filterTime : null,
    onChangeRaw: onChangeRaw,
    onBlur: onBlur,
    className: className,
    isClearable: true,
    clearButtonClassName: clearButtonClassName,
    ariaLabelledBy: ariaLabelledBy
  }));
};
DateTimePicker.propTypes = {
  id: _propTypes.string,
  dataTestId: _propTypes.string,
  dateFormat: _propTypes.string,
  timeIntervals: _propTypes.number,
  startOpen: _propTypes.bool,
  disabled: _propTypes.bool,
  use12Hours: _propTypes.bool,
  filterTimeFlag: _propTypes.bool,
  className: _propTypes.string,
  clearButtonClassName: _propTypes.string,
  ariaDescribedBy: _propTypes.string,
  ariaLabelledBy: _propTypes.string,
  onChange: _propTypes.func,
  filterTime: _propTypes.func,
  onChangeRaw: _propTypes.func,
  onBlur: _propTypes.func,
  minDate: _propTypes["default"].instanceOf(Date),
  maxDate: _propTypes["default"].instanceOf(Date),
  value: _propTypes["default"].instanceOf(Date)
};